// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__XwBIs","selects":"Documents_selects__20HLo"};